export default "__VITE_ASSET__ThRiCGim__"